export const INPULSE_ROLE_NAME = 'inpulse';
